function LoadingScreen(props) {
    return (
        <div className="loading-state">
            <div className="message">{props.message}</div>
            <div className="loading"></div>
        </div>
    );
}

export default LoadingScreen;